import { InternalAxiosRequestConfig, AxiosResponse } from "axios";
import Swal from "sweetalert2";

export function setupAxios(axios: any) {
  axios.defaults.baseURL = process.env.REACT_APP_API_ENDPOINT;
  axios.defaults.headers.Accept = "application/json";

  axios.interceptors.request.use(
    (config: InternalAxiosRequestConfig) => {
      // const accessToken = useAuthStore.getState().accessToken
      // if (accessToken) {
      // 	config.headers.Authorization = `Bearer ${accessToken}`
      // }
      return config;
    },
    async (error: any) => {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response: AxiosResponse) => {
      return response;
    },
    async (error: any) => {
      const originalRequest = error?.config;

      if (error?.response?.status === 401 && !originalRequest?._retry) {
        originalRequest._retry = true;
        // const refreshToken = useAuthStore.getState().refreshToken

        // if (refreshToken) {
        // 	// @ts-ignore
        // 	const [isError, request] = mainAxios
        // 		.post('/auth-buyer/refresh-token', undefined, {
        // 			headers: {
        // 				Authorization: `Bearer ${refreshToken}`,
        // 			},
        // 		})
        // 		.then(({ data }) => {
        // 			const { accessToken } = data
        // 			useAuthStore.setState({
        // 				accessToken,
        // 			})
        // 			axios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken

        // 			return [false, axios.request(originalRequest)]
        // 		})
        // 		.catch(error => {
        // 			useAuthStore.getState().clearState()

        // 			return [true, Promise.reject(error)]
        // 		})

        // 	if (isError) {
        // 		useAuthStore.getState().clearState()
        // 		useAuthSessionStore.getState().clearState()
        // 	}

        // 	return Promise.resolve(request)
        // } else {
        // useAuthStore.getState().clearState();
        // useAuthSessionStore.getState().clearState()
        // }
      } else if (
        !error?.response &&
        !JSON.parse(JSON.stringify(error))?.response?.status
      ) {
        Swal.fire({
          title: "ไม่สามารถเชื่อมต่อกับระบบได้",
          text: "กรุณาลองใหม่อีกครั้ง หรือติดต่อผู้ดูแลระบบ",
          icon: "error",
          confirmButtonText: "ตกลง",
        });
      }

      return Promise.reject(error);
    }
  );
}
